const firstDayInPreviousMonth = () => {
  var d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.toISOString()}`.split('T')[0];
};

export default firstDayInPreviousMonth;
